import {createSelector} from 'reselect';

import {getConfig} from 'mattermost-redux/selectors/entities/general';
import {getCurrentTeam} from 'mattermost-redux/selectors/entities/teams';

export const getAllowedGuestDomains = createSelector(
    getConfig,
    (config) => makeDomainsListFormString(config.GuestRestrictCreationToDomains ?? ''),
);

export const getAllowedTeamDomains = createSelector(
    getConfig,
    (config) => makeDomainsListFormString(config.TeamRestrictCreationToDomains ?? ''),

);

export const getAllowedCurrentTeamDomains = createSelector(
    getCurrentTeam,
    (currentTeam) => makeDomainsListFormString(currentTeam?.allowed_domains ?? ''),
);

function makeDomainsListFormString(input: string) {
    return input.split(',').map((domain) => domain.trim()).filter((domain) => domain !== '');
}
